export default {
  getShowcases(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/showcases/home?limit=1000")
        .then(response => {
          context.commit("setShowcases", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  }
};
